import useDocumentsViewModel from './DocumentsViewModel'
import DocumentsTable from './DocumentsTable'
import Pagination from '@components/shared/Pagination'
import UploadDocumentDialog from '@components/shared/Dialogs/UploadDocumentDialog'
import ConfirmationModal from '../shared/ConfirmationModal'
import SearchInput from '@components/shared/SearchInput'
import CircleSpinner from '../shared/CircleSpinner'
import {
    FaDownload,
    FaFileExport,
    FaFileUpload,
    FaCog,
    FaRedo,
    FaTrash,
} from 'react-icons/fa'
import IndeterminateLoadingBar from '@components/shared/IndeterminateLoadingBar'

/* type DocumentsProps = {
    collectionId: string
    deleteDocument: (showDelete: boolean) => void
    editDocument: (showDelete: boolean) => void
    getDocumentName: (getDocumentName: string) => void
    setDocumentInfo: (documentInfo: { id: string; name: string; collectionId?: string }) => void
} */

export const Documents = ({
    collectionId,
    markedDocuments,
    setMarkedDocuments,
    openRunsheetId,
    ...props
}) => {
    
    const vm = useDocumentsViewModel({
        collectionId,
        openRunsheetId,
        markedDocuments,
        setMarkedDocuments,
    })
    
    return (
        
        <div className="collections-Documents !h-auto">
            
            <header className="flex gap-4 w-full sticky top-0 pb-3 bg-base-100 !items-end">
                
                <div className="hidden md:flex grow w-full gap-2 items-end">
                    <div className="pr-4 text-sm">
                        <div className="w-48">
                            Page {vm.pageNumber + 1} of
                            {' '}
                            {Math.round((vm.documents.count / vm.ITEMS_PER_PAGE) || 0)},
                            {' '}
                            Showing {vm.documents.rows?.length ?? '0'}
                        </div>
                        <div>
                            of {vm.documents.count} Results /
                            {' '}
                            Selected: {markedDocuments.length}
                        </div>
                    </div>
                    
                    <div className="flex gap-2">
                        <div className="form-control">
                            <div className="label p-0">
                                <span className="label-text">Progress</span>
                            </div>
                            <select 
                                className="select select-bordered select-xs"
                                value={vm.searchParams.get('doneStatus') || ''}
                                onChange={e => vm.updateSearchParam('doneStatus', e.target.value)}>
                                <option value=""></option>
                                <option value="done">Done</option>
                                <option value="not_done">Not Done</option>
                            </select>
                        </div>
                        
                        <div className="form-control">
                            <div className="label p-0">
                                <span className="label-text">Current Status</span>
                            </div>
                            <select 
                                className="select select-bordered select-xs"
                                value={vm.searchParams.get('currentStatus') || ''}
                                onChange={e => vm.updateSearchParam('currentStatus', e.target.value)}>
                                <option value="">All</option>
                                <option value="uploaded">Preprocessing</option>
                                <option value="saved">Uploaded</option>
                                <option value="processing">Processing</option>
                                <option value="model_applied">Model Applied</option>
                                <option value="failed">Processing Failed</option>
                                <option value="failed_preprocess">Page Generation Failed</option>
                            </select>
                        </div>
                    </div>
                    
                    <SearchInput
                        className="w-full grow search"
                        value={vm.searchParams.get('q') || ''}
                        placeholder="Search documents..."
                        onChange={e => vm.updateSearchParam('q', e.target.value)} />
                
                </div>
                
                <div className="join shrink-0 p-0">
                    <div
                        className="join-item tooltip tooltip-bottom"
                        data-tip="Download selected documents">
                        <button
                            className="join-item btn btn-primary"
                            disabled={!markedDocuments.length || vm.isDownloading}
                            onClick={() => vm.handleDownload()}>
                            <FaDownload className="text-md" />
                            <span className="hidden 2xl:block">
                                Download
                            </span>
                        </button>
                    </div>
                    <div
                        className="join-item tooltip tooltip-bottom"
                        data-tip="Export selected documents annotations">
                        <button
                            className="join-item btn btn-secondary"
                            disabled={!vm.userFileUpload || vm.exporting}
                            onClick={() => vm.exportAnnotations()}>
                            <FaFileExport className="text-md" />
                            <span className="hidden 2xl:block">
                                Export Annotations
                            </span>
                            {vm.exporting && <CircleSpinner className="ml-4" />}
                        </button>
                    </div>
                    {!vm.currentCollection.isParse && (
                        <div
                            className="join-item tooltip tooltip-bottom"
                            data-tip="Upload documents">
                            <button
                                className="join-item btn btn-primary"
                                disabled={!vm.userFileUpload}
                                {...vm.uploadFile}
                                onClick={() => vm.uploadRef.current?.open()}
                                data-test-id="DocumentsUploadFileButton">
                                <FaFileUpload className="text-md" />
                                <span className="hidden 2xl:block tooltip tooltip-bottom">
                                    Upload
                                </span>
                            </button>
                        </div>
                    )}
                    <div
                        className="join-item tooltip tooltip-bottom"
                        data-tip="Process selected documents">
                        <button
                            className="join-item btn btn-primary"
                            disabled={!markedDocuments.length || vm.loadingProcessDocuments}
                            onClick={vm.onProcessDocumentsClick}>
                            <FaCog className="text-md" />
                            <span className="hidden 2xl:block tooltip tooltip-bottom">
                                Process
                            </span>
                            {vm.loadingProcessDocuments && <span className="loading loading-spinner loading-xs" />}
                        </button>
                    </div>
                    {vm.isParseAdmin && (
                        <div
                            className="join-item tooltip tooltip-bottom"
                            data-tip="Reset selected documents">
                            <button
                                className="join-item btn btn-secondary"
                                disabled={!markedDocuments.length}
                                onClick={vm.onResetDocumentsClick}>
                                <FaRedo className="text-md" />
                                <span className="hidden 2xl:block tooltip tooltip-bottom">
                                    Reset
                                </span>
                            </button>
                        </div>
                    )}
                    {vm.canDeleteDocuments && (
                        <div
                            className="join-item tooltip tooltip-bottom"
                            data-tip="Delete selected documents">
                            <button
                                className="join-item btn btn-danger"
                                disabled={!markedDocuments.length}
                                onClick={() => vm.setShowDeletePopup(true)}>
                                <FaTrash className="text-md" />
                                <span className="hidden 2xl:block tooltip tooltip-left">
                                    Delete
                                </span>
                            </button>
                        </div>
                    )}
                </div>
            </header>
            
            <IndeterminateLoadingBar
                className="!h-1 rounded"
                isLoading={vm.isLoading}
                colorClass="bg-base-200/50"
                altColorClass="bg-base-300/50" />
            
            <DocumentsTable
                ref={vm.uploadRef}
                onDrop={vm.onDrop}
                headers={vm.headers}
                orderField={vm.orderField}
                orderDirection={vm.orderDirection}
                onHeaderClick={vm.onHeaderClick}
                isParseAdmin={vm.isParseAdmin}
                canDeleteDocuments={vm.canDeleteDocuments}
                collectionId={collectionId}
                currentCollection={vm.currentCollection}
                template={vm.templateName}
                inheritedFrom={vm.inheritedFrom}
                documents={vm.documents?.rows || []}
                markedDocuments={markedDocuments}
                setMarkedDocuments={setMarkedDocuments}
                editDocument={props.editDocument}
                setDocumentInfo={props.setDocumentInfo}
                deleteDocument={props.deleteDocument}
                getDocumentName={props.getDocumentName}
                itemsPerPage={vm.itemsPerPage}
                forcePage={vm.forcePage}
                setPageIndex={vm.setPageIndex} />
            
            {vm.documents.count > 1 && (
                <div className="flex justify-center w-full mx-auto sticky bottom-[0] bg-dark py-2">
                    <Pagination
                        count={vm.documents.count}
                        itemsPerPage={vm.ITEMS_PER_PAGE}
                        forcePage={vm.pageNumber}
                        setPageIndex={vm.setPageNumber} />
                </div>
            )}
            
            {vm.uploadDialogOpen && <UploadDocumentDialog
                open={vm.uploadDialogOpen}
                setOpen={vm.setUploadDialogOpen}
                files={vm.uploadData}
                setUpdateDocs={vm.setUpdateDocs}
                collectionId={collectionId} />}
            
            <ConfirmationModal
                showModal={vm.showDeletePopup}
                showHideModal={vm.setShowDeletePopup}
                onConfirm={vm.onDeleteDocumentsClick}
                title="Delete documents"
                message={'This will delete the selected documents.' +
                    '\nThis action is irreversible!' +
                    '\nPress "Yes" to confirm.'} />
        
        </div>
    )
}
